import React from 'react';
import { isLoggedIn, logout } from '@/api/base';
import { Box, Button, Divider, Stack, Text } from '@chakra-ui/react';
import { storage } from '@/utils/storage';
import { User } from '@shop/models/src/identity';
import { RxExit } from 'react-icons/rx';
import { Link, useNavigate } from 'react-router-dom';
import ConfirmationModal from '../confirmation-modal';
import { useCartCtx } from '@/app/cart/context/cart';

type ProfilePopupProps = { onLogin: VoidFunction; onClose: VoidFunction };
export default function ProfilePopup({ onLogin, onClose }: ProfilePopupProps) {
  return isLoggedIn() ? (
    <LoggedIn onClose={onClose} />
  ) : (
    <LoggedOut onLogin={onLogin} />
  );
}

type LoggedOutProps = Omit<ProfilePopupProps, 'onClose'>;
function LoggedOut({ onLogin }: LoggedOutProps) {
  return (
    <Stack>
      <Text fontWeight={600}>شما هنوز وارد نشدید!</Text>
      <Button
        bgColor={'black'}
        color={'white'}
        size={'sm'}
        mt={2}
        onClick={onLogin}
      >
        ورود به پینتورا
      </Button>
    </Stack>
  );
}

type LoggedInProps = Omit<ProfilePopupProps, 'onLogin'>;
function LoggedIn({ onClose }: LoggedInProps) {
  const navigate = useNavigate();
  const { clearCart } = useCartCtx();

  const user = storage.local.user.get<User>();
  const address = user.addresses[0];

  return (
    <Stack spacing={2}>
      <Box>
        <Text fontWeight={600}>{address?.name || user.mobileNumber}</Text>
        <Text fontSize={'xs'} color={'teal.600'}>
          به پینتورا خوش اومدی!
        </Text>
      </Box>
      <Divider />
      {[
        { link: '/order', text: 'سفارشات' },
        // TODO:
        // { link: '/design/history', text: 'طراحی ها' },
        // { link: '/user/addresses', text: 'آدرس ها' },
      ].map((item, index) => (
        <React.Fragment key={index}>
          <Link to={item.link} onClick={onClose}>
            <Text fontSize={'13px'} fontWeight={600}>
              {item.text}
            </Text>
          </Link>
          <Divider />
        </React.Fragment>
      ))}

      <ConfirmationModal
        title="خروج از حساب کاربری"
        confirm={{
          title: 'خروج',
          onClick: ({ close }) => {
            logout();
            clearCart();
            close();
            if (window.location.pathname.replace(/(\?.*)$/, '') !== '/') {
              navigate('/');
            }
          },
        }}
        trigger={
          <Button
            variant={'ghost'}
            color={'red.500'}
            leftIcon={<RxExit size={20} />}
            size={'sm'}
            justifyContent={'flex-start'}
            px={0}
          >
            خروج
          </Button>
        }
        width={'400px'}
      >
        <Text>می خواهید از حساب کاربری خود خارج شوید؟</Text>
      </ConfirmationModal>
    </Stack>
  );
}
